import React from 'react';
import PriceIsRightPayAtOrder from './pay-at-order';
import CompletePurchaseShell from '../complete-purchase-shell';
import type { CompletePurchasePayAtOrderRenderProps } from '../complete-purchase-shell';
import type { CompletePurchaseStepProps } from '../complete-purchase.types';

const renderPayAtOrder = (props: CompletePurchasePayAtOrderRenderProps) => (
  <PriceIsRightPayAtOrder {...props} />
);

const CompletePurchaseTreatment: React.FC<CompletePurchaseStepProps> = props => {
  return <CompletePurchaseShell {...props} renderPayAtOrder={renderPayAtOrder} />;
};

export default CompletePurchaseTreatment;
